import { Theme, useMediaQuery } from '@mui/material'
import { useMemo } from 'react'

interface MediaSize {
  buttonSize: 'small' | 'medium' | 'large'
  inputSize: 'small' | 'medium'
  isTablet: boolean
  isPhone: boolean
  isMobileDevice: boolean
}

export const useMediaSize = () => {
  const isTablet = useMediaQuery<Theme>((theme) => theme.breakpoints.only('sm'))
  const isPhone = useMediaQuery<Theme>((theme) => theme.breakpoints.only('xs'))
  const inputSize = isPhone ? 'small' : 'medium'
  const buttonSize = isTablet ? 'large' : inputSize
  const isMobileDevice = isTablet || isPhone

  return useMemo(
    (): MediaSize => ({
      buttonSize,
      inputSize,
      isTablet,
      isPhone,
      isMobileDevice,
    }),
    [buttonSize, inputSize, isTablet, isPhone, isMobileDevice]
  )
}
